import { i18n_config_default } from './chunk-5FPUWZMY.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/reportsList.ts
var reportTimeFactory = (report) => {
  switch (report.period) {
    case "custom" /* CUSTOM */: {
      const startDate = new Date(report.startDate).toLocaleDateString();
      const endDate = new Date(report.endDate).toLocaleDateString();
      return `${startDate} - ${endDate}`;
    }
    default:
      return getPeriodTranslation(report.period);
  }
};
var getPeriodTranslation = (period) => i18n_config_default.t(`reports.fields.periodOptions.${period}`);
var reportRowFactory = (report) => __spreadProps(__spreadValues({}, report), {
  title: report.name,
  time: reportTimeFactory(report),
  activeFilter: report.isActive ? 1 : 2,
  bucket: "creditCardBatchReports",
  bucketId: 0
});

export { getPeriodTranslation, reportRowFactory, reportTimeFactory };
